export class ApiError extends Error {
  constructor(message: string, code: any) {
    super(message);
    this.message = message;
    this.code = code;
  }
}

export class TimeoutError extends Error {
  constructor() {
    const msg = "Timeout error";
    super(msg);
  }
}
